import { whooshPrimitives } from "./primitives";

type WhooshIconColorTokens = {
  "icon-primary": string;
  "icon-inverse": string;
  "icon-main-primary": string;
  "icon-main-secondary": string;
  "icon-disabled": string;
  "icon-subtle": string;
  "icon-status-success": string;
  "icon-status-warning": string;
  "icon-status-error": string;
  "icon-inverse-subtle": string;
  "icon-on-color-success": string;
  "icon-on-color-warning": string;
  "icon-on-color-error": string;
  "icon-on-color-blue": string;
  "icon-on-color-purple": string;
  "icon-on-color-pink": string;
  "icon-on-color-user-selectable-a": string;
  "icon-on-color-user-selectable-b": string;
  "icon-on-color-user-selectable-c": string;
  "icon-on-color-user-selectable-d": string;
  "icon-on-color-user-selectable-e": string;
  "icon-on-color-user-selectable-f": string;
};

export const whooshIconColors: WhooshIconColorTokens = {
  "icon-primary": whooshPrimitives.grayscale[1000],
  "icon-inverse": whooshPrimitives.grayscale[0],
  "icon-main-primary": whooshPrimitives.main.primary[500],
  "icon-main-secondary": whooshPrimitives.main.secondary[500],
  "icon-disabled": whooshPrimitives.grayscale[700],
  "icon-subtle": whooshPrimitives.grayscale[700],
  "icon-status-success": whooshPrimitives.status.success[500],
  "icon-status-warning": whooshPrimitives.status.warning[500],
  "icon-status-error": whooshPrimitives.status.error[500],
  "icon-inverse-subtle": whooshPrimitives.grayscale[700],
  "icon-on-color-success": whooshPrimitives.main.primary[700],
  "icon-on-color-warning": whooshPrimitives.status.warning[800],
  "icon-on-color-error": whooshPrimitives.status.error[700],
  "icon-on-color-blue": whooshPrimitives.accent.blue[700],
  "icon-on-color-purple": whooshPrimitives.accent.purple[700],
  "icon-on-color-pink": whooshPrimitives.accent.pink[700],
  "icon-on-color-user-selectable-a": whooshPrimitives.userSelectable.A[800],
  "icon-on-color-user-selectable-b": whooshPrimitives.userSelectable.B[800],
  "icon-on-color-user-selectable-c": whooshPrimitives.userSelectable.C[700],
  "icon-on-color-user-selectable-d": whooshPrimitives.userSelectable.D[700],
  "icon-on-color-user-selectable-e": whooshPrimitives.userSelectable.E[700],
  "icon-on-color-user-selectable-f": whooshPrimitives.userSelectable.F[700],
};
